import { render, staticRenderFns } from "./BpOptionsMenu.vue?vue&type=template&id=0d853c1d&scoped=true&"
import script from "./BpOptionsMenu.vue?vue&type=script&lang=js&"
export * from "./BpOptionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BpOptionsMenu.vue?vue&type=style&index=0&id=0d853c1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d853c1d",
  null
  
)

export default component.exports